var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFalse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36714 0.555948L0.531653 3.39144C-0.177218 4.10031 -0.177218 5.33736 0.531653 6.22692L10.3169 16.0121L0.531653 25.7973C-0.177218 26.6869 -0.177218 27.924 0.531653 28.6328L3.36714 31.4683C4.2567 32.1772 5.49375 32.1772 6.20263 31.4683L15.9878 21.6831L25.773 31.4683C26.6626 32.1772 27.8997 32.1772 28.6085 31.4683L31.444 28.6328C32.1529 27.7433 32.1529 26.5062 31.444 25.7973L21.6588 16.0121L31.444 6.22692C32.1529 5.33736 32.1529 4.10031 31.444 3.39144L28.6085 0.555948C27.719 -0.152923 26.4819 -0.152923 25.773 0.555948L15.9878 10.3412L6.20263 0.555948C5.37498 -0.103587 4.15694 -0.233857 3.36714 0.555948Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalse);
export default __webpack_public_path__ + "static/media/false.e11e9be5.svg";
export { ForwardRef as ReactComponent };